import Vue from "vue";
import Vuelidate from "vuelidate";
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import FormGroup from "@/components/shared/validation/form-group.vue";
import FormSummary from "@/components/shared/validation/form-summary.vue";

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(VuelidateErrorExtractor, {
  i18n: "validation"
});
Vue.component("FormGroup", FormGroup);
Vue.component("FormSummary", FormSummary);
Vue.component("FormWrapper", templates.FormWrapper);
